import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _promise = null;

export const fetchFeatures = () => {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = api.get("/features")
      .then(({ data }) => { _cache = data; return data; })
      .catch(() => ({ instructor_features: false }));
  }
  return _promise;
};

export const refreshFeatures = () => { _cache = null; _promise = null; return fetchFeatures(); };

export const useFeatures = () => {
  const [f, setF] = useState(_cache || { instructor_features: false });
  useEffect(() => { fetchFeatures().then(setF); }, []);
  return f;
};
